export const QueryKeys: string[] = [
  'viewedInterestsPage',
  'viewedMctPhi',
  'viewedPrivacyPreferencesPage',
  'viewedTelehealthPage',
];

export type Api3CTAKeys = {
  [key: string]: boolean | undefined;
  viewedInterestsPage?: boolean;
  viewedMctPhi?: boolean;
  viewedPrivacyPreferencesPage?: boolean;
  viewedTelehealthPage?: boolean;
};

export type Api3CTA = {
  data: Api3CTAKeys;
};
